import { apiClient } from './apiClient';


export const adminLogin = async (email, password) => {
  try {
    const result = await apiClient('/admin/auth/login', {
      method: 'POST',
      body: JSON.stringify({
        email,
        password,
      }),
    });
    return result;
  } catch (error) {
    if (error.message.includes('권한') || error.message.includes('인증') || error.message.includes('401') || error.message.includes('403')) {
      throw new Error('아이디 또는 비밀번호가 일치하지 않습니다.');
    }
    throw error;
  }
};


export const saveAuthData = (data, rememberMe = false) => {
  clearAuthData();

  const storage = rememberMe ? localStorage : sessionStorage;

  storage.setItem('accessToken', data.accessToken);
  storage.setItem('adminData', JSON.stringify({
    admin_id: data.admin_id,
    name: data.name,
    email: data.email,
    role: data.role,
  }));
};


export const getAccessToken = () => {
  return localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken');
};

export const getAdminData = () => {
  const data = localStorage.getItem('adminData') || sessionStorage.getItem('adminData');
  return data ? JSON.parse(data) : null;
};


export const clearAuthData = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('adminData');
  sessionStorage.removeItem('accessToken');
  sessionStorage.removeItem('adminData');
};


export const isAuthenticated = () => {
  return !!getAccessToken();
};